import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {PointLight, PointLightParameters} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-point-light-inspector",
    templateUrl: "./point-light-inspector.component.html",
    styleUrl: "./point-light-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class PointLightInspectorComponent extends BaseInspectorComponent<PointLight> {
    readonly $lightTypePossibilites = signal<SelectionPossibilities<PointLightParameters["lightType"]>>([
        {value: "Corona", name: "Corona"},
        {value: "Blender", name: "Blender"},
    ])
}
